module.exports = __webpack_public_path__ + "img/img_案例03.792c9e59.png";